// extracted by mini-css-extract-plugin
module.exports = {"main":"BotText_main_yBHh9","content":"BotText_content_2RWkU"};